export default function ArrowRightBigIcon({
  width = 16,
  height = 16,
  color = "#000000",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6738 4.51988C5.939 4.20167 6.41191 4.15868 6.73012 4.42385C7.04833 4.68903 7.09132 5.16195 6.82615 5.48016L5.3513 7.25H12.25C12.6642 7.25 13 7.58579 13 8C13 8.41421 12.6642 8.75 12.25 8.75H5.3512L6.82615 10.5199C7.09132 10.8381 7.04833 11.311 6.73012 11.5762C6.41191 11.8414 5.939 11.7984 5.6738 11.4802L3.1738 8.48016C2.942 8.20202 2.942 7.79802 3.1738 7.51988L5.6738 4.51988Z"
        fill={color}
      />
    </svg>
  );
}
